const CART_KEY = "lfx_cart";

let cartListeners = [];

const notifyCartListeners = () => {
  cartListeners.forEach((f) => f());
};

export const subCart = (fn) => {
  cartListeners.push(fn);
  return () => {
    cartListeners = cartListeners.filter((s) => s !== fn);
  };
};

export const cartLineKey = (productId, color) =>
  `${String(productId)}::${String(color || "").trim() || "default"}`;

export const readCart = () => {
  try {
    const raw = localStorage.getItem(CART_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

export const writeCart = (lines) => {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(Array.isArray(lines) ? lines : []));
  } catch (e) {
    // ignore quota / private mode
  }
  notifyCartListeners();
};

export const getCartCount = () =>
  readCart().reduce((acc, line) => acc + (Number(line.qty) || 0), 0);

export const cartTotals = (cart) => {
  const lines = cart || readCart();
  let subtotal = 0;
  lines.forEach((line) => {
    const unit = Number(line.unitPrice);
    const q = Number(line.qty) || 1;
    if (Number.isFinite(unit)) subtotal += unit * q;
  });
  return { subtotal, lineCount: lines.length };
};

export const addToCartLine = (line) => {
  const { productId, color, qty: qtyRaw, ...rest } = line;
  const qtyIn = Number(qtyRaw);
  const addQty = Number.isFinite(qtyIn) && qtyIn > 0 ? qtyIn : 1;
  const key = cartLineKey(productId, color);
  const cart = readCart();
  const idx = cart.findIndex((l) => l.key === key);
  if (idx >= 0) {
    const prev = Number(cart[idx].qty) || 1;
    cart[idx] = {
      ...cart[idx],
      ...rest,
      key,
      productId: String(productId),
      color: color || "",
      qty: Math.min(99, prev + addQty),
    };
  } else {
    cart.push({
      key,
      productId: String(productId),
      color: color || "",
      qty: Math.min(99, addQty),
      ...rest,
    });
  }
  writeCart(cart);
};

export const setLineQty = (key, qty) => {
  let n = Number(qty);
  if (!Number.isFinite(n) || n < 1) {
    removeLine(key);
    return;
  }
  if (n > 99) n = 99;
  const cart = readCart().map((l) => (l.key === key ? { ...l, qty: n } : l));
  writeCart(cart);
};

export const removeLine = (key) => {
  writeCart(readCart().filter((l) => l.key !== key));
};

export const clearCartStorage = () => {
  writeCart([]);
};
